import React from 'react';
import { SettingsItem } from 'design-system/SettingsItem';
import { IconDoubleRotateBold, IconTrash } from 'design-system/icons';
import IconBlock from 'design-system/icons/IconBlock';
import { rem, Spacer } from 'design-system';
import Modal from 'utils/packages/Modal';
import { isWeb } from '../../../../constants';
const ManageBankConnectionModalContent = ({ isClosed, toggleConnectionClosed, onDelete }) => (<>
    <Spacer.H8 />
    {isClosed ? (<SettingsItem title="Mark as open" description="The bank will start syncing again" onPress={() => ManageBankConnectionModal.hide(toggleConnectionClosed)} icon={<IconDoubleRotateBold colorKey="statusPositive"/>}/>) : (<SettingsItem title="Mark as closed" description="The bank will stop syncing, but your historical data will remain in the app" onPress={() => ManageBankConnectionModal.hide(toggleConnectionClosed)} icon={<IconBlock colorKey="statusOffline"/>}/>)}
    <SettingsItem title="Delete connection" description="Disconnect this bank. All associated data will be removed from Emma" onPress={() => ManageBankConnectionModal.hide(onDelete)} icon={<IconTrash colorKey="statusNegative"/>}/>
  </>);
const ManageBankConnectionModal = {
    show: (props) => {
        Modal.show(<ManageBankConnectionModalContent {...props}/>, {
            title: 'Manage bank connection',
            containerStyle: { paddingHorizontal: isWeb ? rem(8) : 0 },
        });
    },
    hide: Modal.hide,
};
export default ManageBankConnectionModal;
